// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { readAllNotifications } from '../../../apis/member'
import { readAllNotificationsActions } from '../../actionCreators/notifications/readAllNotificationsActions';
import { RootAction } from '../../rootActionCreator';

const outputActions = {
  success: readAllNotificationsActions.success,
  failure: readAllNotificationsActions.failure
};

type RequestActionTypes = ActionType<typeof readAllNotificationsActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const readAllNotificationsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(readAllNotificationsActions.request)
    ),
    switchMap(async (action: RequestActionTypes) => {
      const {
        success
      } = action.payload;

      return readAllNotifications()
        .then(() => {
          success();
          return outputActions.success({});
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return outputActions.failure({ error });
        });
    })
  );
};
